// extracted by mini-css-extract-plugin
export default {"SlotList":"SlotList_SlotList__-ifdY","embiggen":"SlotList_embiggen__MFIuR"};